import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NHFetch from '../../utils/NHFetch';
import { sstj_school, getSstjComponent, baseSstjComponent } from './Config'
import { Spin, message } from 'antd'
const basicUrl = '/yxxc/'; //基础请求路径

/**
 * 实时统计页面，根据schoolCode来展示相应的组件
 */
class SstjIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            schoolCode: 'lydx',  //学校代码
            SstjComp: baseSstjComponent,   //大屏显示使用的组件
            isloadingsstj: false,  //是否展示大屏loading  
        }
    }

    componentWillMount() {
       

    }

    componentDidMount() { 
        let match = this.props.match;
        if(match !=null && match != undefined){
            let { pkid,csbz } = this.props.match.params; 
            sessionStorage.setItem('pkid',pkid);
            this.getSstj(csbz);
            console.log("this.props.match---",this.props.match,pkid,csbz)
        }else{
            sessionStorage.setItem('pkid',""); 
            this.getSstj("YXXT_DPXS_SCHOOL");
        } 
        
    }

    /** 获取实时统计页面 */
    getSstj = (csbz) => {     
        this.setState({ isloadingsstj: true })
        // 这个接口用的是获取参数配置的接口
        NHFetch(basicUrl + 'getReadCsxx', 'GET', { csbz: csbz })
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ schoolCode: data }, () => {
                            // 获取的学校编号，根据学校编号查出相应的报到单
                            let schoolCode = this.state.schoolCode;
                            this.setState({
                                SstjComp: getSstjComponent(schoolCode, 'SstjComponent') ? getSstjComponent(schoolCode, 'SstjComponent') : baseSstjComponent
                            })
                        });
                        this.setState({ isloadingsstj: false })
                    } else {
                        this.setState({ isloadingsstj: false })
                    }
                } else {
                    this.setState({ isloadingsstj: false })
                }
            });

        // this.setState({
        //     SstjComp: getSstjComponent(school,'SstjComponent') ? getSstjComponent(school,'SstjComponent') : baseSstjComponent
        // })


    }
    // text: center;
    //             background: rgba(0, 0, 0, 0.05);
    //             border-radius: 4px;
    //             margin-bottom: 20px;
    //             padding: 30px 50px;
    //             margin: 20px 0;
    render() {
        const { isloadingsstj, SstjComp } = this.state;
        //let { pkid, csbz1} = this.props.match.params;
        
        return (
            // this.getSstj('lydx')

            isloadingsstj ?
                <div style={{
                    backgroundColor: 'rgb(0,0,0,0)',
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Spin size="large" />
                </div>
                : <SstjComp />



            // <SstjComp />
        );
    }
}

SstjIndex.propTypes = {

};

export default SstjIndex;


// WEBPACK FOOTER //
// ./containers/Sstj/index.js